var _symbol;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-reports",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.05,169.7V58.68H80.02V169.7L271.05,169.7L271.05,169.7z M95.02,73.68h161.04v81.02H95.02V73.68z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.04,
    y: 89.52,
    className: "st0",
    width: 128.99,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.04,
    y: 119.52,
    className: "st0",
    width: 128.99,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.17,0H39.32C17.64,0,0,17.64,0,39.32c0,0,0,332.51,0,332.51c0,21.68,17.64,39.32,39.32,39.32h22.91v44.82 h55.9v-44.82h208.04L326.17,0z M311.17,332.51H46.82V15h264.35V332.51z M31.82,16.19v317.03c-6.14,1.18-11.88,3.81-16.82,7.71 V39.32C15,28.53,22.07,19.36,31.82,16.19z M39.32,396.15c-13.41,0-24.32-10.91-24.32-24.32c0-6.51,2.53-12.62,7.12-17.21 c4.59-4.59,10.7-7.12,17.2-7.12h22.91v48.65H39.32z M77.23,440.98v-93.47h25.9v93.47L77.23,440.98L77.23,440.98z M311.17,396.15 H118.13v-48.65h193.04L311.17,396.15L311.17,396.15z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.67a0764de61d6dc20212f26a4ba748dd.svg";
export { ForwardRef as ReactComponent };